import { render } from "./GroupList.vue?vue&type=template&id=bd95082a"
import script from "./GroupList.vue?vue&type=script&lang=js"
export * from "./GroupList.vue?vue&type=script&lang=js"

import "./GroupList.vue?vue&type=style&index=0&id=bd95082a&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__